import React, { useState, useMemo } from "react";
import { BusinessCategory } from "../../pages";

import BusinessCategoryController from "../../controllers/BusinessCategoryController";

const BusinessCategoryContainer = () => {
  const [loading, setLoading] = useState(false);
  const [addCategoryModal, setAddCategoryModal] = useState(false);
  const [editCategoryModal, setEditCategoryModal] = useState(false);
  const [deleteCategoryModal, setDeleteCategoryModal] = useState(false);

  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const businessCategoryTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching, refetch } =
    BusinessCategoryController.useGetBusinessCategories(
      businessCategoryTableQuery,
      filterQuery,
      searchQuery
    );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const goToAddCategoryModal = () => {
    setAddCategoryModal(true);
  };
  const goToEditCategoryModal = () => {
    setEditCategoryModal(true);
  };
  const goToDeleteCategoryModal = () => {
    setDeleteCategoryModal(true);
  };

  const closeModal = () => {
    setAddCategoryModal(false);
    setEditCategoryModal(false);
    setDeleteCategoryModal(false);
  };

  return (
    <BusinessCategory
      goToDeleteCategoryModal={goToDeleteCategoryModal}
      deleteCategoryModal={deleteCategoryModal}
      goToAddCategoryModal={goToAddCategoryModal}
      addCategoryModal={addCategoryModal}
      goToEditCategoryModal={goToEditCategoryModal}
      editCategoryModal={editCategoryModal}
      closeModal={closeModal}
      isLoading={isLoading}
      bizCategorydata={data}
      isFetching={isFetching}
      limit={limit}
      onLimitChange={onLimitChange}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      setSearchQuery={setSearchQuery}
      refetch={refetch}
    />
  );
};
export default BusinessCategoryContainer;
